import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';
import { DefaultSeo, NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

import OpportunityJsonLd from '@atoms/JsonLd/OpportunityJsonLd';

import { getUrlFromRoute } from '@app/helpers';

function OpportunitySeo({opportunity, isApply}) {
    const router = useRouter();
    const title = isApply ? opportunity.title : `Apply to - ${opportunity.title}`;
    const description = opportunity.summary || (opportunity.description && opportunity.description.slice(0, 200));
    const opportunityUrl = getUrlFromRoute('view_opportunity', { 
        params: {
            slug: opportunity.slug
        },
        locale: router.locale
    });
    const applyUrl = getUrlFromRoute('form_viewer', { 
        params: {
            slug: opportunity.slug
        },
        locale: router.locale
    });

    const mediaList = opportunity.gallery ? opportunity.gallery.map((image) => ({url: image.path})) : [];
    return (
        <>
            <DefaultSeo
                title={title}
                locale
                description={description}
                openGraph={{
                    url: isApply ? applyUrl: opportunityUrl,
                    title,
                    description,
                    images: [
                        {
                            url: opportunity.logo.path,
                            width: 800,
                            height: 600,
                            alt: `Cover - ${title}`,
                        },
                        ...mediaList
                    ],
                    site_name: 'Mubazar',
                }}
            />
            { opportunity.start_date && 
                <OpportunityJsonLd
                    url={opportunityUrl}
                    title={opportunity.title}
                    description={description}
                    images={[opportunity.logo.path, ...mediaList.map(({url})=> url)]}
                    location={!opportunity.is_virtual && opportunity.location ? opportunity.location : null}
                    startDate={moment(opportunity.start_date)}
                    offerUrl={applyUrl}
                    paymentInfo={opportunity.is_paid? opportunity.payment_details: null}
                    endDate={moment(opportunity.end_date)}
                    createDate={moment(opportunity.created_at)}
                    organisation={opportunity.organisation}
                /> 
            }
        </>
    )
}


OpportunitySeo.propTypes = {
    opportunity: PropTypes.object.isRequired,
    isApply: PropTypes.bool
};

OpportunitySeo.defaultProps = {
    isApply: false
};

export default OpportunitySeo
